<template>
    <div class="container">
        <section class="page-discount">
            <header>
                <div class="headerText">
                    <h1 class="title">{{ discount.title }} <span>Explained</span></h1>
                    <div class="subtitle">{{ discount.subtitle }}</div>
                </div>
                <div class="headerAmount">
                    {{ discount.amount }}
                </div>
            </header>
            <section class="discountBody" v-html="discount.body" />
            <footer class="discountFooter">
                <button class="button" @click="back">Ok, got it</button>
            </footer>
        </section>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import discounts from '../../data/discounts'

export default {
    components: {},
    props: {
        title: String,
        subtitle: String,
        amount: String,
        body: String,
        name: String
    },
    computed: {
        ...mapState([
            'lead', 
            'system',
        ]),
        discount()  {
            let name = this.$route.query.name
            let discount = discounts[name]
            if (name === 'totalInvestment') {
                discount.amount = this.system.totalFormatted
                discount.body = `
                    <div class="totalInvestmentModelContent">
                        <section class="section">
                            <div class="row">
                                <div class="column">
                                    <h3>Total Equipment Cost</h3>
                                </div>
                                <div class="column">
                                    ${this.system.equipmentCost}
                                </div> 
                            </div>
                            <div class="row">
                                <div class="column">
                                    The total cost of your equipment purchased online through trueecurity.
                                </div>
                            </div>
                        </section>
                        <section>
                            <div class="row">
                                <div class="column">
                                    <h3>Installation and activation</h3>
                                </div>
                                <div class="column">
                                    ${this.system.installationCost}
                                </div> 
                            </div>
                            <div class="row">
                                <div class="column">
                                    You system needs to be installed and professioanly connected to ADT’s network of redundant monitoring centers. 
                                </div>
                            </div>
                        </section>
                    </div>
                `
            }
            return discount
        }
    },
    methods: {
        ...mapActions([]),
        back() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="css" scoped> </style>
